import { useEffect, useRef, useState } from "react";
import { Search } from "lucide-react";

// Input controlado localmente + debounce: evita duplicados del IME (Samsung/Gboard).
export const OrdersSearch = ({ q, onApply }) => {
  const [localQ, setLocalQ] = useState(q);
  const composingRef = useRef(false);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (q !== localQ && !composingRef.current && !debounceRef.current) setLocalQ(q);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q]);

  function schedule(v) {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(function run() {
      if (composingRef.current) { debounceRef.current = setTimeout(run, 150); return; }
      debounceRef.current = null;
      onApply(v);
    }, 350);
  }

  return (
    <div className="relative flex-1">
      <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 pointer-events-none" />
      <input
        type="text"
        value={localQ}
        onChange={(e) => { setLocalQ(e.target.value); if (!composingRef.current) schedule(e.target.value); }}
        onCompositionStart={() => { composingRef.current = true; }}
        onCompositionEnd={(e) => { composingRef.current = false; const v = e.currentTarget.value; setLocalQ(v); schedule(v); }}
        inputMode="search"
        enterKeyHint="search"
        autoComplete="off"
        autoCorrect="off"
        spellCheck={false}
        placeholder="Buscar por # de orden, cliente, teléfono, serial/IMEI…"
        className="input-base !pl-11"
        data-testid="orders-search-input"
      />
    </div>
  );
};
